import { render } from "./inq_item.vue?vue&type=template&id=ab762d52"
import script from "./inq_item.vue?vue&type=script&lang=js"
export * from "./inq_item.vue?vue&type=script&lang=js"

import "./inq_item.vue?vue&type=style&index=0&id=ab762d52&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__